<template>
  <div>
    <BannerNotice
      v-if="showFileErrorBanner > 0"
      :message="failedFileUploadMessage"
    />
    <NominateForm
      ref="NominateForm"
      class="content"
      :nomination-id="nominationId"
      :prefill-form-data="prefillFormData"
      :uploaded-files="uploadedFiles"
      :uploaded-logos="uploadedLogos"
      :submitted="submitted"
      submit-label="Save Changes"
      @files-changed="getUploadedFiles"
      @submit="submit"
      @submit-and-pay="submitAndPay"
    />
  </div>
</template>

<script>
import NominateForm from '@/components/NominateForm'
import BannerNotice from '@/components/BannerNotice'
import { updateNomination, getNomination, getNominationFiles } from '@/services/HttpSvc'
import { USER_NOMINATIONS, USER_NOMINATIONS_PAYMENT } from '@/core/constants'

const nominationId = Number(location.pathname.split('/')[4])
const showFileErrorBanner = Number(new URLSearchParams(window.location.search).get('fileUploadFailed'))

export default {
  name: 'EditNomination',

  components: {
    NominateForm,
    BannerNotice,
  },

  data() {
    return {
      nominationId,
      showFileErrorBanner,
      failedFileUploadMessage: 'One or more files failed to upload. Your nomination was saved successfully. Try uploading your file attachement(s) again.',
      prefillFormData: {},
      uploadedFiles: [],
      uploadedLogos: [],
      submitted: false,
    }
  },

  async created() {
    if (this.nominationId) {
      this.getNomination()
      this.getUploadedFiles()
    }
  },

  mounted() {
    // remove the query parameters so the banner doesn't continue to show up
    if(showFileErrorBanner && window.location.search.substring(1).length) {
       window.history.pushState({}, document.title, window.location.pathname);
    }
  },

  methods: {
    async submitNomination(formData, redirectUrl) {
      try {
        await updateNomination(formData)
        const uploadFilesResp = await this.$refs.NominateForm.uploadFiles()

        if (uploadFilesResp.failed.length >= 1) {
          //console.error('File upload failed! uploadFilesResp: ', uploadFilesResp)
        } else {
          //console.debug('File upload success! uploadFilesResp: ', uploadFilesResp)
          window.location = redirectUrl
        }
      } catch(err) {
        //console.error('nomination failed', err)
      }
    },

    async submit(formData) {
      await this.submitNomination(formData, USER_NOMINATIONS)
    },

    async submitAndPay(formData) {
      await this.submitNomination(formData, USER_NOMINATIONS_PAYMENT)
    },

    async getUploadedFiles() {
      const { files, logos } = await getNominationFiles(this.nominationId)
      this.uploadedFiles = files
      this.uploadedLogos = logos
    },

    async getNomination() {
      const nominationData = await getNomination(this.nominationId)
      this.submitted = nominationData.submitted || false
      this.prefillFormData = nominationData
    },

  },
}
</script>
